"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _default = function _default(onScroll) {
  var handleScroll = (0, _react.useCallback)(function () {
    return onScroll({
      x: window.scrollX,
      y: window.scrollY
    });
  }, [onScroll]);
  (0, _react.useEffect)(function () {
    window.addEventListener('scroll', handleScroll);
    return function () {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
};

exports["default"] = _default;